import { render } from "./UpdateSelfAmbassador.vue?vue&type=template&id=5cdd3155&ts=true"
import script from "./UpdateSelfAmbassador.vue?vue&type=script&lang=ts"
export * from "./UpdateSelfAmbassador.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__